var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 6.66667C1.6665 6.66667 5.39746 2.5 9.99984 2.5C14.6022 2.5 18.3332 6.66667 18.3332 6.66667",
    stroke: "#656F7D",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9532 10.8708C18.2065 11.226 18.3332 11.4037 18.3332 11.6666C18.3332 11.9295 18.2065 12.1072 17.9532 12.4624C16.8148 14.0588 13.9075 17.4999 9.99984 17.4999C6.09215 17.4999 3.18492 14.0588 2.04654 12.4624C1.79318 12.1072 1.6665 11.9295 1.6665 11.6666C1.6665 11.4037 1.79318 11.226 2.04654 10.8708C3.18492 9.27442 6.09215 5.83325 9.99984 5.83325C13.9075 5.83325 16.8148 9.27442 17.9532 10.8708Z",
    stroke: "#656F7D",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 11.6667C12.5 10.286 11.3807 9.16675 10 9.16675C8.61925 9.16675 7.5 10.286 7.5 11.6667C7.5 13.0475 8.61925 14.1667 10 14.1667C11.3807 14.1667 12.5 13.0475 12.5 11.6667Z",
    stroke: "#656F7D",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.1e8b6e5dbf411a6065849c7b3c08c6b7.svg";
export { ForwardRef as ReactComponent };